import React from "react";
import {TestList} from "../tests";

export default function CurrentTests(): any {
    return (
        <div className="w-full flex flex-col md:flex-row justify-center mx-5 pt-4 max-h-full">
            <TestList finished={false} active={true} title={"Ongoing Tests"}/>
            <TestList finished={false} active={false} title={"Paused Tests"}/>
        </div>
    );
}